// BlogListSkeleton.jsx
import React from "react";

const BlogListSkeleton = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 animate-pulse">

      <div className="h-8 bg-gray-300 rounded w-48 mx-auto mb-10"></div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

        {/* BLOG GRID SKELETON */}
        <div className="md:col-span-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="bg-white rounded-lg shadow p-4">
                
                <div className="w-full h-40 bg-gray-300 rounded mb-4"></div>

                <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
                <div className="h-3 bg-gray-200 rounded w-1/3"></div>

              </div>
            ))}
          </div>
        </div>

        {/* SIDEBAR SKELETON */}
        <div className="md:col-span-1">
          <div className="bg-white rounded-lg shadow p-4">

            <div className="h-5 bg-gray-300 rounded w-32 mb-4"></div>

            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex gap-3 mb-4">
                <div className="w-14 h-14 bg-gray-300 rounded"></div>

                <div className="flex-1">
                  <div className="h-3 bg-gray-300 rounded w-3/4 mb-2"></div>
                  <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                </div>
              </div>
            ))}

          </div>
        </div>

      </div>
    </div>
  );
};

export default BlogListSkeleton;